<template>
<div class="con-menu">
  <div class="menu sticky-container">
   <span class="cont-back">
     <a href="#" class="btn btn-outline-secondary btn-sm back" @click="goBack">⏴-</a>
   </span>
    <!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ $t('modifiche_piatto') }}</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <span v-if="add.length">{{ $t('aggiunte_possibili') }}</span>
        <div v-for="ad in add" :key="ad">
        <input type="checkbox" v-model="aggiunte" class="add"   :name="ad" :value="ad"/>
        <label :for="ad">{{ad}}</label>
        </div>
        <span v-if="remove.length">{{ $t('possono_togliere') }}</span>
        <div v-for="rem in remove" :key="rem">
          <input type="checkbox" v-model="senza" class="remove"  :name="rem" :value="rem"/>
          <label :for="rem">{{rem}}</label>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success" data-bs-dismiss="modal" @click="createOrdineFromModal">{{ $t('aggiungi') }}</button>
      </div>
    </div>
  </div>
</div>
    <div class="order v-sticky" :sticky-offset="offset" sticky-side="right" v-if="tok">
      <span @click="()=> displayOrdine = !displayOrdine">{{ $t('ordinazione') }}</span><br/>
      <div class="check-cont">
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="antipasti-radio" v-model="checked" value="1°" checked>
            <label class="form-check-label" for="antipasti-radio">
            {{ $t('portata_1') }}
            </label>
        </div>
        <div class="form-check">
        <input class="form-check-input" type="radio" name="flexRadioDefault" id="primi-radio" v-model="checked"  value="2°">
        <label class="form-check-label" for="primi-radio">
        {{ $t('portata_2') }}
        </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="secondi-radio" v-model="checked" value="3°">
          <label class="form-check-label" for="secondi-radio">
          {{ $t('portata_3') }}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="quarta-radio" v-model="checked" value="4°">
          <label class="form-check-label" for="quarta-radio">
          {{ $t('portata_4') }}
          </label>
        </div>
      </div>
      <div class="vis-ordine" v-if="displayOrdine">
        <div class="mb-2 text-center">
          <a href="#" class="btn btn-outline-success btn-sm w-100 fw-bold" @click.prevent="inviaOrdine">{{ $t('conferma_ordine') }}</a>
        </div>
        <div class="riepilogo" v-for="(o,ind) in ordine" :key="o.nome || ind">
          <div class="con-piatti">
          <a href="#" class="btn btn-outline-warning btn-sm" @click="(e)=>deleteP(ind)">Delete</a>
          <div class="nome">{{o.ordine}},</div>
          <div class="nome">{{o.piatto}},</div>
          <div class="aggiunte" v-if="o.aggiunta && o.aggiunta.length">+{{o.aggiunta.toString()}}</div>
          <div class="senza" v-if="o.senza && o.senza.length">-{{o.senza.toString()}}</div>
          <div class="quantita">Qta {{o.quantita}},</div>
          <div class="prezzo-tot">{{ $t('totale') }} {{o.prezzo * o.quantita}} €</div>
          </div>
        </div>
      </div>
      </div>

    <!-- Category Filter Bar -->
    <div class="category-filter-container">
      <div class="category-filter">
        <div 
          class="category-item" 
          :class="{ active: selectedCategory === 'all' }"
          @click="selectedCategory = 'all'"
        >
          <div class="cat-icon"><i class="fas fa-th-large"></i></div>
          <span class="cat-label">{{ $t('tutti') || 'Tutti' }}</span>
        </div>
        <div 
          v-for="cat in categories" 
          :key="cat.id"
          class="category-item" 
          :class="{ active: selectedCategory === cat.id, hidden: !hasItemsInCategory(cat.id) }"
          @click="selectedCategory = cat.id"
          v-show="hasItemsInCategory(cat.id)"
        >
          <div class="cat-icon"><i :class="cat.icon"></i></div>
          <span class="cat-label">{{ $t(cat.id) }}</span>
        </div>
      </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'antipasti'">
      <span class="txt first" v-if="antipasti.length">{{ $t('nostri_antipasti') }}</span>
      <div class="cont-antipasti cont-menu">
        <div class="card antipasto"  v-for="antipasto in antipasti" :key="antipasto.nome">
      <img v-if="antipasto.immagine" class="card-img-top dish-img" :src="antipasto.immagine" :alt="antipasto.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(antipasto)}}</h5>
        <div v-if="getTranslatedDesc(antipasto) || getAllergeni(antipasto)" class="description-container" :class="{ expanded: antipasto.expanded }">
          <p class="card-text">{{getTranslatedDesc(antipasto)}}</p>
          <div v-if="getAllergeni(antipasto)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(antipasto) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{antipasto.prezzo}} €</div>
          <button v-if="getTranslatedDesc(antipasto) || getAllergeni(antipasto)" class="btn-info-toggle" @click="toggleDetails(antipasto)" :title="$t('dettagli')">
            <i class="fas" :class="antipasto.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,antipasto.nome,antipasto.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="antipasto.addProd.length || antipasto.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(antipasto.nome, antipasto.prezzo, antipasto.addProd,antipasto.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'primi'">
      <div class="txt " v-if="primi.length">{{ $t('nostri_primi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card primi"  v-for="primo in primi" :key="primo.nome">
      <img v-if="primo.immagine" class="card-img-top dish-img" :src="primo.immagine" :alt="primo.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(primo)}}</h5>
        <div v-if="getTranslatedDesc(primo) || getAllergeni(primo)" class="description-container" :class="{ expanded: primo.expanded }">
          <p class="card-text">{{getTranslatedDesc(primo)}}</p>
          <div v-if="getAllergeni(primo)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(primo) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{primo.prezzo}} €</div>
          <button v-if="getTranslatedDesc(primo) || getAllergeni(primo)" class="btn-info-toggle" @click="toggleDetails(primo)" :title="$t('dettagli')">
            <i class="fas" :class="primo.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,primo.nome,primo.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="primo.addProd.length || primo.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(primo.nome, primo.prezzo, primo.addProd,primo.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'secondi'">
      <div class="txt" v-if="secondi.length">{{ $t('nostri_secondi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card secondi"  v-for="secondo in secondi" :key="secondo.nome">
      <img v-if="secondo.immagine" class="card-img-top dish-img" :src="secondo.immagine" :alt="secondo.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(secondo)}}</h5>
        <div v-if="getTranslatedDesc(secondo) || getAllergeni(secondo)" class="description-container" :class="{ expanded: secondo.expanded }">
          <p class="card-text">{{getTranslatedDesc(secondo)}}</p>
          <div v-if="getAllergeni(secondo)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(secondo) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{secondo.prezzo}} €</div>
          <button v-if="getTranslatedDesc(secondo) || getAllergeni(secondo)" class="btn-info-toggle" @click="toggleDetails(secondo)" :title="$t('dettagli')">
            <i class="fas" :class="secondo.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
     <footer class="fot " v-if="tok">
       <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,secondo.nome,secondo.prezzo)">{{ $t('aggiungi') }}</a>
       <a href="#" v-if="secondo.addProd.length || secondo.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(secondo.nome, secondo.prezzo, secondo.addProd,secondo.removeProd)">{{ $t('modifica') }}</a>
       </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'contorni'">
      <div class="txt" v-if="contorni.length">{{ $t('nostri_contorni') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="contorno in contorni" :key="contorno.nome">
      <img v-if="contorno.immagine" class="card-img-top dish-img" :src="contorno.immagine" :alt="contorno.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(contorno)}}</h5>
        <div v-if="getTranslatedDesc(contorno) || getAllergeni(contorno)" class="description-container" :class="{ expanded: contorno.expanded }">
          <p class="card-text">{{getTranslatedDesc(contorno)}}</p>
          <div v-if="getAllergeni(contorno)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(contorno) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{contorno.prezzo}} €</div>
          <button v-if="getTranslatedDesc(contorno) || getAllergeni(contorno)" class="btn-info-toggle" @click="toggleDetails(contorno)" :title="$t('dettagli')">
            <i class="fas" :class="contorno.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,contorno.nome,contorno.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="contorno.addProd.length || contorno.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(contorno.nome, contorno.prezzo, contorno.addProd,contorno.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'pizza'">
      <div class="txt" v-if="pizze.length">{{ $t('nostra_pizza') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="pizza in pizze" :key="pizza.nome">
      <img v-if="pizza.immagine" class="card-img-top dish-img" :src="pizza.immagine" :alt="pizza.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(pizza)}}</h5>
        <div v-if="getTranslatedDesc(pizza) || getAllergeni(pizza)" class="description-container" :class="{ expanded: pizza.expanded }">
          <p class="card-text">{{getTranslatedDesc(pizza)}}</p>
          <div v-if="getAllergeni(pizza)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(pizza) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{pizza.prezzo}} €</div>
          <button v-if="getTranslatedDesc(pizza) || getAllergeni(pizza)" class="btn-info-toggle" @click="toggleDetails(pizza)" :title="$t('dettagli')">
            <i class="fas" :class="pizza.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,pizza.nome,pizza.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="pizza.addProd.length || pizza.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(pizza.nome, pizza.prezzo, pizza.addProd,pizza.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

        <div v-show="selectedCategory === 'all' || selectedCategory === 'focaccia'">
      <div class="txt" v-if="focacce.length">{{ $t('nostra_focaccia') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card focaccia" v-for="focaccia in focacce" :key="focaccia.nome">
          <img v-if="focaccia.immagine" class="card-img-top dish-img" :src="focaccia.immagine" :alt="focaccia.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(focaccia)}}</h5>
            <div v-if="getTranslatedDesc(focaccia) || getAllergeni(focaccia)" class="description-container" :class="{ expanded: focaccia.expanded }">
              <p class="card-text">{{getTranslatedDesc(focaccia)}}</p>
              <div v-if="getAllergeni(focaccia)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(focaccia) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{focaccia.prezzo}} €</div>
              <button v-if="getTranslatedDesc(focaccia) || getAllergeni(focaccia)" class="btn-info-toggle" @click="toggleDetails(focaccia)" :title="$t('dettagli')">
                <i class="fas" :class="focaccia.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,focaccia.nome,focaccia.prezzo)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="focaccia.addProd.length || focaccia.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(focaccia.nome, focaccia.prezzo, focaccia.addProd,focaccia.removeProd)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>
    <div v-show="selectedCategory === 'all' || selectedCategory === 'trancio'">
      <div class="txt" v-if="tranci.length">{{ $t('nostro_trancio') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card trancio" v-for="trancio in tranci" :key="trancio.nome">
          <img v-if="trancio.immagine" class="card-img-top dish-img" :src="trancio.immagine" :alt="trancio.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(trancio)}}</h5>
            <div v-if="getTranslatedDesc(trancio) || getAllergeni(trancio)" class="description-container" :class="{ expanded: trancio.expanded }">
              <p class="card-text">{{getTranslatedDesc(trancio)}}</p>
              <div v-if="getAllergeni(trancio)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(trancio) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{trancio.prezzo}} €</div>
              <button v-if="getTranslatedDesc(trancio) || getAllergeni(trancio)" class="btn-info-toggle" @click="toggleDetails(trancio)" :title="$t('dettagli')">
                <i class="fas" :class="trancio.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,trancio.nome,trancio.prezzo)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="trancio.addProd.length || trancio.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(trancio.nome, trancio.prezzo, trancio.addProd,trancio.removeProd)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>


    <div v-show="selectedCategory === 'all' || selectedCategory === 'teglia'">
      <div class="txt" v-if="teglie.length">{{ $t('nostra_teglia') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card teglia" v-for="teglia in teglie" :key="teglia.nome">
          <img v-if="teglia.immagine" class="card-img-top dish-img" :src="teglia.immagine" :alt="teglia.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(teglia)}}</h5>
            <div v-if="getTranslatedDesc(teglia) || getAllergeni(teglia)" class="description-container" :class="{ expanded: teglia.expanded }">
              <p class="card-text">{{getTranslatedDesc(teglia)}}</p>
              <div v-if="getAllergeni(teglia)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(teglia) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{teglia.prezzo}} €</div>
              <button v-if="getTranslatedDesc(teglia) || getAllergeni(teglia)" class="btn-info-toggle" @click="toggleDetails(teglia)" :title="$t('dettagli')">
                <i class="fas" :class="teglia.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,teglia.nome,teglia.prezzo)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="teglia.addProd.length || teglia.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(teglia.nome, teglia.prezzo, teglia.addProd,teglia.removeProd)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'combo'">
      <div class="txt" v-if="combos.length">{{ $t('nostra_combo') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card combo" v-for="combo in combos" :key="combo.nome">
          <img v-if="combo.immagine" class="card-img-top dish-img" :src="combo.immagine" :alt="combo.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(combo)}}</h5>
            <div v-if="getTranslatedDesc(combo) || getAllergeni(combo)" class="description-container" :class="{ expanded: combo.expanded }">
              <p class="card-text">{{getTranslatedDesc(combo)}}</p>
              <div v-if="getAllergeni(combo)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(combo) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{combo.prezzo}} €</div>
              <button v-if="getTranslatedDesc(combo) || getAllergeni(combo)" class="btn-info-toggle" @click="toggleDetails(combo)" :title="$t('dettagli')">
                <i class="fas" :class="combo.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,combo.nome,combo.prezzo)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="combo.addProd.length || combo.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(combo.nome, combo.prezzo, combo.addProd,combo.removeProd)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'insalate'">
      <div class="txt" v-if="insalate.length">{{ $t('nostre_insalate') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card insalate" v-for="insalata in insalate" :key="insalata.nome">
          <img v-if="insalata.immagine" class="card-img-top dish-img" :src="insalata.immagine" :alt="insalata.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(insalata)}}</h5>
            <div v-if="getTranslatedDesc(insalata) || getAllergeni(insalata)" class="description-container" :class="{ expanded: insalata.expanded }">
              <p class="card-text">{{getTranslatedDesc(insalata)}}</p>
              <div v-if="getAllergeni(insalata)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(insalata) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{insalata.prezzo}} €</div>
              <button v-if="getTranslatedDesc(insalata) || getAllergeni(insalata)" class="btn-info-toggle" @click="toggleDetails(insalata)" :title="$t('dettagli')">
                <i class="fas" :class="insalata.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,insalata.nome,insalata.prezzo)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="insalata.addProd.length || insalata.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(insalata.nome, insalata.prezzo, insalata.addProd,insalata.removeProd)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>
    <div v-show="selectedCategory === 'all' || selectedCategory === 'sushi'">
      <div class="txt" v-if="sushi.length">{{ $t('nostro_sushi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="sus in sushi" :key="sus.nome">
      <img v-if="sus.immagine" class="card-img-top dish-img" :src="sus.immagine" :alt="sus.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(sus)}}</h5>
        <div v-if="getTranslatedDesc(sus) || getAllergeni(sus)" class="description-container" :class="{ expanded: sus.expanded }">
          <p class="card-text">{{getTranslatedDesc(sus)}}</p>
          <div v-if="getAllergeni(sus)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(sus) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{sus.prezzo}} €</div>
          <button v-if="getTranslatedDesc(sus) || getAllergeni(sus)" class="btn-info-toggle" @click="toggleDetails(sus)" :title="$t('dettagli')">
            <i class="fas" :class="sus.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,sus.nome,sus.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="sus.addProd.length || sus.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(sus.nome, sus.prezzo, sus.addProd,sus.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'dolci'">
      <div class="txt" v-if="dolci.length">{{ $t('nostri_dolci') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card dolci"  v-for="dolce in dolci" :key="dolce.nome">
      <img v-if="dolce.immagine" class="card-img-top dish-img" :src="dolce.immagine" :alt="dolce.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(dolce)}}</h5>
        <div v-if="getTranslatedDesc(dolce) || getAllergeni(dolce)" class="description-container" :class="{ expanded: dolce.expanded }">
          <p class="card-text">{{getTranslatedDesc(dolce)}}</p>
          <div v-if="getAllergeni(dolce)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(dolce) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{dolce.prezzo}} €</div>
          <button v-if="getTranslatedDesc(dolce) || getAllergeni(dolce)" class="btn-info-toggle" @click="toggleDetails(dolce)" :title="$t('dettagli')">
            <i class="fas" :class="dolce.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,dolce.nome,dolce.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="dolce.addProd.length || dolce.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(dolce.nome, dolce.prezzo, dolce.addProd,dolce.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'poke'">
      <div class="txt" v-if="poke.length">{{ $t('nostro_poke') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card poke"  v-for="pokeItem in poke" :key="pokeItem.nome">
      <img v-if="pokeItem.immagine" class="card-img-top dish-img" :src="pokeItem.immagine" :alt="pokeItem.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(pokeItem)}}</h5>
        <div v-if="getTranslatedDesc(pokeItem) || getAllergeni(pokeItem)" class="description-container" :class="{ expanded: pokeItem.expanded }">
          <p class="card-text">{{getTranslatedDesc(pokeItem)}}</p>
          <div v-if="getAllergeni(pokeItem)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(pokeItem) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{pokeItem.prezzo}} €</div>
          <button v-if="getTranslatedDesc(pokeItem) || getAllergeni(pokeItem)" class="btn-info-toggle" @click="toggleDetails(pokeItem)" :title="$t('dettagli')">
            <i class="fas" :class="pokeItem.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,pokeItem.nome,pokeItem.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="pokeItem.addProd.length || pokeItem.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(pokeItem.nome, pokeItem.prezzo, pokeItem.addProd,pokeItem.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'frutta'">
      <div class="txt" v-if="frutta.length">{{ $t('nostra_frutta') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card frutta"  v-for="frutto in frutta" :key="frutto.nome">
      <img v-if="frutto.immagine" class="card-img-top dish-img" :src="frutto.immagine" :alt="frutto.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(frutto)}}</h5>
        <div v-if="getTranslatedDesc(frutto) || getAllergeni(frutto)" class="description-container" :class="{ expanded: frutto.expanded }">
          <p class="card-text">{{getTranslatedDesc(frutto)}}</p>
          <div v-if="getAllergeni(frutto)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(frutto) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{frutto.prezzo}} €</div>
          <button v-if="getTranslatedDesc(frutto) || getAllergeni(frutto)" class="btn-info-toggle" @click="toggleDetails(frutto)" :title="$t('dettagli')">
            <i class="fas" :class="frutto.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,frutto.nome,frutto.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="frutto.addProd.length || frutto.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(frutto.nome, frutto.prezzo, frutto.addProd,frutto.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'amari'">
      <div class="txt" v-if="amari.length">{{ $t('nostri_amari') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card amari"  v-for="amaro in amari" :key="amaro.nome">
      <img v-if="amaro.immagine" class="card-img-top dish-img" :src="amaro.immagine" :alt="amaro.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(amaro)}}</h5>
        <div v-if="getTranslatedDesc(amaro) || getAllergeni(amaro)" class="description-container" :class="{ expanded: amaro.expanded }">
          <p class="card-text">{{getTranslatedDesc(amaro)}}</p>
          <div v-if="getAllergeni(amaro)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(amaro) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{amaro.prezzo}} €</div>
          <button v-if="getTranslatedDesc(amaro) || getAllergeni(amaro)" class="btn-info-toggle" @click="toggleDetails(amaro)" :title="$t('dettagli')">
            <i class="fas" :class="amaro.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,amaro.nome,amaro.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="amaro.addProd.length || amaro.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(amaro.nome, amaro.prezzo, amaro.addProd,amaro.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'bevande'">
      <div class="txt" v-if="bevande.length">{{ $t('nostre_bevande') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card bevande"  v-for="bevanda in bevande" :key="bevanda.nome">
      <img v-if="bevanda.immagine" class="card-img-top dish-img" :src="bevanda.immagine" :alt="bevanda.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(bevanda)}}</h5>
        <div v-if="getTranslatedDesc(bevanda) || getAllergeni(bevanda)" class="description-container" :class="{ expanded: bevanda.expanded }">
          <p class="card-text">{{getTranslatedDesc(bevanda)}}</p>
          <div v-if="getAllergeni(bevanda)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(bevanda) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{bevanda.prezzo}} €</div>
          <button v-if="getTranslatedDesc(bevanda) || getAllergeni(bevanda)" class="btn-info-toggle" @click="toggleDetails(bevanda)" :title="$t('dettagli')">
            <i class="fas" :class="bevanda.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,bevanda.nome,bevanda.prezzo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="bevanda.addProd.length || bevanda.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(bevanda.nome, bevanda.prezzo, bevanda.addProd,bevanda.removeProd)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>
    <div v-show="selectedCategory === 'all' || selectedCategory === 'calice'">
      <div class="txt" v-if="calice.length">{{ $t('nostro_calice') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card calice" v-for="caliceItem in calice" :key="caliceItem.nome">
          <img v-if="caliceItem.immagine" class="card-img-top dish-img" :src="caliceItem.immagine" :alt="caliceItem.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(caliceItem)}}</h5>
            <div v-if="getTranslatedDesc(caliceItem) || getAllergeni(caliceItem)" class="description-container" :class="{ expanded: caliceItem.expanded }">
              <p class="card-text">{{getTranslatedDesc(caliceItem)}}</p>
              <div v-if="getAllergeni(caliceItem)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(caliceItem) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{caliceItem.prezzo}} €</div>
              <button v-if="getTranslatedDesc(caliceItem) || getAllergeni(caliceItem)" class="btn-info-toggle" @click="toggleDetails(caliceItem)" :title="$t('dettagli')">
                <i class="fas" :class="caliceItem.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click="(e)=> createOrdine(e,caliceItem.nome,caliceItem.prezzo)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="caliceItem.addProd.length || caliceItem.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="(e)=> canChange(caliceItem.nome, caliceItem.prezzo, caliceItem.addProd,caliceItem.removeProd)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>


  </div>
</div>
</template>


<script>
// @ is an alias to /src
import { store } from '../store/store.js'
import Sticky from 'vue-sticky-directive'
import moment from 'moment'
import { io } from "socket.io-client"
  const socket = io(process.env.VUE_APP_SOCKET_URL, { autoConnect: false });
export default {
  name: 'Menu',
  directives: {Sticky},
  data: function(){

      return {
        piatti:[],
        antipasti:[],
        primi:[],
        secondi:[],
        contorni:[],
        pizze:[],
        sushi:[],
        dolci:[],
        frutta:[],
        caffe:[],
        amari:[],
        bevande:[],
        calice:[],
        poke:[],
        tranci:[],
        focacce:[],
        teglie:[],
        combos:[],
        insalate:[],
        orderCard:['primi','secondi','focaccia', 'trancio','teglia', 'combo', 'insalate','poke','contorni','dolci','frutta','amari','caffe','bevande','calice'],
        displayOrdine:false,
        ordine:[],
        checked:'1° portata',
        position:false,
        date: new Date(),
        tm:'',
        add:[],
        remove:[],
        aggiunte:[],
        senza:[],
        selectedNome: null,
        selectedPrezzo: null,
        selectedCategory: 'all',
        categories: [
          { id: 'antipasti', label: 'nostri_antipasti', icon: 'fas fa-concierge-bell' },
          { id: 'primi', label: 'nostri_primi', icon: 'fas fa-utensils' },
          { id: 'secondi', label: 'nostri_secondi', icon: 'fas fa-drumstick-bite' },
          { id: 'poke', label: 'nostro_poke', icon: 'fas fa-concierge-bell' },
          { id: 'contorni', label: 'nostri_contorni', icon: 'fas fa-leaf' },
          { id: 'pizza', label: 'nostra_pizza', icon: 'fas fa-pizza-slice' },
          { id: 'focaccia', label: 'nostra_focaccia', icon: 'fas fa-bread-slice' },
          { id: 'trancio', label: 'nostro_trancio', icon: 'fas fa-pizza-slice' },
          { id: 'teglia', label: 'nostra_teglia', icon: 'fas fa-layer-group' },
          { id: 'sushi', label: 'nostro_sushi', icon: 'fas fa-fish' },
          { id: 'combo', label: 'nostra_combo', icon: 'fas fa-plus-circle' },
          { id: 'insalate', label: 'nostre_insalate', icon: 'fas fa-leaf' },
          { id: 'dolci', label: 'nostri_dolci', icon: 'fas fa-ice-cream' },
          { id: 'amari', label: 'nostri_amari', icon: 'fas fa-glass-martini-alt' },
          { id: 'bevande', label: 'nostre_bevande', icon: 'fas fa-wine-bottle' },
          { id: 'calice', label: 'nostro_calice', icon: 'fas fa-wine-glass' },

        ],
        tok:localStorage.getItem('token')?localStorage.getItem('token'):'',
        store
      }
  },
  methods: {
    socketConnect () {
      socket.connect();
    },
    socketOrdine (sala,tavolo) {
        socket.emit('nuovoOrdine',{sala,tavolo},()=>{

        });
    },
    displayMenu() {
        this.axios.post(this.store.path+'displayMenu').then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Le Sale sono state caricate correttamente')
            }else{console.log('Non è stato possibile caricare le sale')}
            response.data.messaggio.forEach(element => {
                  element.expanded = false;
                  this.piatti.push(element);
            });
            this.createOrderCard();
        })
    },
    createOrderCard (){
      this.piatti.forEach(element =>{
        console.log(element.portata)
        if(element.portata == 'antipasti') {this.antipasti.push(element)}
        if(element.portata == 'primi') {this.primi.push(element)}
        if(element.portata == 'secondi') {this.secondi.push(element)}
        if(element.portata == 'contorni') {this.contorni.push(element)}
        if(element.portata == 'pizza') {this.pizze.push(element)}
        if(element.portata == 'focaccia') {this.focacce.push(element)}
        if(element.portata == 'trancio') {this.tranci.push(element)}
        if(element.portata == 'teglia') {this.teglie.push(element)}
        if(element.portata == 'combo') {this.combos.push(element)}
        if(element.portata == 'insalate') {this.insalate.push(element)}
        if(element.portata == 'sushi') {this.sushi.push(element)}
        if(element.portata == 'dolci') {this.dolci.push(element)}
        if(element.portata == 'caffe') {this.caffe.push(element)}
        if(element.portata == 'frutta') {this.frutta.push(element)}
        if(element.portata == 'amari') {this.amari.push(element)}
        if(element.portata == 'bevande') {this.bevande.push(element)}
        if(element.portata == 'calice') {this.calice.push(element)}
        if(element.portata == 'poke') {this.poke.push(element)}
      })

    },
    canChange (nome, prezzo, add, remove) {
      this.selectedNome = nome;
      this.selectedPrezzo = prezzo;
      this.add= add;
      this.remove=remove;
      this.aggiunte=[];
      this.senza=[];
    },
    createOrdine (e,nome,prezzo) {
      this.ordine.push({quantita:1,piatto:nome,prezzo:prezzo,ordine:this.checked,aggiunta:[],senza:[]})
    },
    getTranslatedName(item) {
      if (!item) return '';
      const locale = this.$i18n.locale;
      if (locale === 'en') return item.nomeEn || item.nome;
      if (locale === 'es') return item.nomeEs || item.nome;
      return item.nome;
    },
    getTranslatedDesc(item) {
      if (!item) return '';
      const locale = this.$i18n.locale;
      if (locale === 'en') return item.descrizioneEn || item.descrizione;
      if (locale === 'es') return item.descrizioneEs || item.descrizione;
      return item.descrizione;
    },
    createOrdineFromModal() {
      if (this.selectedNome) {
        this.ordine.push({
          quantita: 1, 
          piatto: this.selectedNome, 
          prezzo: this.selectedPrezzo, 
          ordine: this.checked, 
          aggiunta: this.aggiunte, 
          senza: this.senza
        });
        this.aggiunte=[];
        this.senza=[];
        this.selectedNome = null;
        this.selectedPrezzo = null;
      }
    },
    deleteP(ind) {
      this.ordine.splice(ind,1)
    },
    toggleDetails(dish) {
      dish.expanded = !dish.expanded;
    },
  inviaOrdine() {
    this.tm = moment(this.date).unix();
    let stored = localStorage.getItem('ordineAttuale');
    let sala = '';
    let tavolo = '';
    let coperti = 0;
    if (stored) {
      let parsed = JSON.parse(stored);
      sala = parsed.sala;
      tavolo = parsed.tavolo;
      coperti = parsed.coperti || 0;
    } else {
      var position = (this.position || "").split('-');
      if (position.length >= 2) {
        sala = position[0].slice(2, position[0].length);
        tavolo = position[1].slice(0, position[1].length -1);
      }
    }

    this.axios.post(this.store.path+ `creaOrdine`,{
      coperti: coperti,
      sala: sala,
      tavolo: tavolo,
      ordinazione: this.ordine,
      tm: this.tm,
      headers:{ authorization: `Bearer  ${JSON.parse(localStorage.token)}`}
    }).then((response) => {
      if(response.data){
        console.log('Ordinazione Creata con Successo');
        this.ordine=[];
        this.socketOrdine(sala, tavolo);
        this.$router.push({ name: "Sala" });
      }else{
        console.log('Non è stato possibile Aggiornare il menu')
      }
    }).catch((err) => {
      console.error("Errore invio ordine:", err);
    });
  },
  hasItemsInCategory(catId) {
    if (catId === 'antipasti') return this.antipasti.length > 0;
    if (catId === 'primi') return this.primi.length > 0;
    if (catId === 'secondi') return this.secondi.length > 0;
    if (catId === 'contorni') return this.contorni.length > 0;
    if (catId === 'pizza') return this.pizze.length > 0;
    if (catId === 'sushi') return this.sushi.length > 0;
    if (catId === 'dolci') return this.dolci.length > 0;
    if (catId === 'amari') return this.amari.length > 0;
    if (catId === 'bevande') return this.bevande.length > 0;
    if(catId === 'calice') return this.calice.length > 0;
    if(catId === 'poke') return this.poke.length > 0;
    if(catId === 'trancio') return this.tranci.length > 0;
    if(catId === 'focaccia') return this.focacce.length > 0;
    if(catId === 'teglia') return this.teglie.length > 0;
    if(catId === 'combo') return this.combos.length > 0;
    if(catId === 'insalate') return this.insalate.length > 0;
    return false;
  },
  getAllergeni(item) {
    if (!item) return '';
    const locale = this.$i18n.locale;
    if (locale === 'en') return item.allergeniEn || item.allergeni;
    if (locale === 'es') return item.allergeniEs || item.allergeni;
    return item.allergeni;
  },
  goBack() {
    this.$router.push({ name: "Home"})
  }

  },
  

  beforeMount() {
      if(!this.position){
        this.position = localStorage.getItem('tavolo');
      }
      if (this.$route.query.category) {
        this.selectedCategory = this.$route.query.category;
      }
        this.displayMenu()
        this.socketConnect()
    },
}
</script>

<style scoped>
.con-menu{
  overflow-y: scroll;
  height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Inter', sans-serif;
  padding-bottom: 50px;
}

.menu {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.txt {
  font-size: 2rem;
  font-weight: 800;
  color: #2c3e50;
  margin: 30px 20px 15px;
  text-transform: capitalize;
  border-bottom: 2px solid #eaeaea;
  padding-bottom: 10px;
}
.first {
  margin-top: 10vh;
}

.cont-menu {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 0 20px;
}

.card {
  height: 100%;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.12);
}

.card-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.card-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 8px;
}

.card-text {
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 15px;
  flex-grow: 1;
}

.prezzo-text {
  font-weight: 700;
  font-size: 1.15rem;
  color: #e74c3c;
  margin-bottom: 0px;
}

.fot {
  margin-top: auto;
  padding-top: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.description-container {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.4s ease, opacity 0.3s ease;
  opacity: 0;
  margin-bottom: 0;
}

.description-container.expanded {
  max-height: 300px; /* Increased to accommodate allergens */
  opacity: 1;
  margin-bottom: 15px;
}

.allergeni-info {
  margin-top: 10px;
  font-size: 0.85rem;
  color: #e67e22;
  border-top: 1px solid rgba(0,0,0,0.05);
  padding-top: 8px;
}

.allergeni-info strong {
  color: #d35400;
}

.card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.btn-info-toggle {
  background: none;
  border: none;
  color: #3498db;
  cursor: pointer;
  font-size: 1.1rem;
  padding: 5px;
  transition: transform 0.3s ease, color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-info-toggle:hover {
  color: #2980b9;
  transform: scale(1.1);
}

.btn-info-toggle i {
  transition: transform 0.3s ease;
}

.order {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100vw;
  background: rgba(44, 62, 80, 0.92);
  color: #ecf0f1;
  z-index: 2000;
  padding: 6px 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.25);
  backdrop-filter: blur(15px);
  border-bottom: 3px solid #f1c40f;
  transition: transform 0.3s ease;
}

.order > span {
  font-size: 0.9rem;
  font-weight: 800;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 5px;
  color: #f1c40f;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}

.check-cont {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  justify-content: flex-start;
  gap: 12px;
  background: rgba(255,255,255,0.08);
  padding: 8px;
  border-radius: 8px;
  scrollbar-width: none;
}
.check-cont::-webkit-scrollbar { display: none; }

.form-check-label {
  margin-left: 5px;
  font-weight: 500;
  cursor: pointer;
}

.vis-ordine {
  margin-top: 15px;
  max-height: 60vh;
  overflow-y: auto;
  border-top: 1px solid rgba(255,255,255,0.2);
  padding-top: 15px;
}

.riepilogo {
  margin-bottom: 10px;
  background: rgba(255,255,255,0.05);
  padding: 10px;
  border-radius: 8px;
}

.con-piatti {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.nome {
  font-weight: 600;
  font-size: 1.1rem;
}

.aggiunte, .senza {
  font-size: 0.9rem;
  font-style: italic;
  opacity: 0.9;
}
.aggiunte { color: #2ecc71; }
.senza { color: #e74c3c; }

.quantita {
  font-size: 1rem;
  color: #bdc3c7;
}

.prezzo-tot {
  font-weight: bold;
  font-size: 1.1rem;
  color: #f1c40f;
  margin-left: auto;
}

.btn-success {
  background-color: #2ecc71;
  border-color: #2ecc71;
}
.btn-success:hover {
  background-color: #27ae60;
  border-color: #27ae60;
}

.btn-outline-success {
  color: #2ecc71;
  border-color: #2ecc71;
}
.btn-outline-success:hover {
  background-color: #2ecc71;
  color: white;
}

.btn {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 6px 12px;
}

.back {
  border-radius: 50% !important;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px !important;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  background-color: white;
  color: #333;
  border: none;
  text-decoration: none;
}
.back:hover {
  background-color: #f1f1f1;
}

.cont-back {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 101;
}

.dish-img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
  background-color: #f8f9fa;
}

/* Category Filter Bar Styles */
.category-filter-container {
  position: sticky;
  top: -3px; /* Sit right below the compact header */
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  padding: 15px 0;
  margin: 10px 0 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border-bottom: 1px solid rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.category-filter {
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding: 0 20px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  justify-content: flex-start;
}

.category-filter::-webkit-scrollbar {
  display: none;
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 65px;
  height: 65px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  padding: 10px;
  border-radius: 18px;
  background: #f8f9fa;
  border: 1px solid rgba(0,0,0,0.05);
  color: #2c3e50;
}

.category-item:hover {
  transform: translateY(-3px);
  background-color: white;
  box-shadow: 0 8px 15px rgba(0,0,0,0.1);
}

.category-item.active {
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  color: white;
  box-shadow: 0 10px 20px rgba(46, 204, 113, 0.4);
  border: none;
  transform: scale(1.05);
}

.category-item.active .cat-icon i {
  color: white;
}

.cat-icon {
  font-size: 1.3rem;
  margin-bottom: 4px;
}

.cat-icon i {
  color: #2ecc71;
  transition: all 0.3s ease;
}

.cat-label {
  font-size: 0.6rem;
  font-weight: 800;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}

.first {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .category-filter-container {
    top: -3px;
    padding: 8px 0;
  }
  .category-item {
    min-width: 100px;
    height: 100px;
    border-radius: 12px;
    padding: 5px;
  }
  .cat-label {
    /* display: none; */
    /* invece di nasconderla rimpiccioliscila */
    font-size: 0.5rem;
  }
  .cat-icon {
    margin-bottom: 0;
    font-size: 1.2rem;
  }
  .txt {
    font-size: 1.4rem;
    margin: 20px 15px 10px;
  }
}

</style>